import {isCheckedIn} from "./kiosk";

// service's size helpers
const hasOnlyOne = (services) => services.length === 1;

export const hasMoreThanOne = (services) => services.length > 1;

const hasNone = (services) => !services.length;

const hasAtLeastOne = (services) => services.length > 0;

export const isSingleServiceKiosk = hasOnlyOne;

export const isMultiServiceKiosk = hasMoreThanOne;

// helpers
export const servicesCheckedIn = (kioskServices) => kioskServices.filter(isCheckedIn);

const isCheckedInSelectedService = (servicesCheckedInto, selectedService) =>
  servicesCheckedInto.some(service => service.serviceId === selectedService.serviceId);

const isNotCheckedInSingleKioskService = (kioskServices) =>
  hasNone(servicesCheckedIn(kioskServices)) && isSingleServiceKiosk(kioskServices);

// sign in routers
export const isCheckedInIntoOneServiceInAMultiServiceKiosk = (kioskServices) =>
  hasOnlyOne(servicesCheckedIn(kioskServices)) && isMultiServiceKiosk(kioskServices);

// Checks if student is checked into some other service in this multi-service kiosk and not in selected service.
// We use it in virtual check-in flow, so we take student to screen that checks if they want to proceed with checking in or not.
export const isCheckedInAnotherServiceInAMultiServiceKioskAndNotInSelectedService = (kioskServices, selectedService) =>
  isMultiServiceKiosk(kioskServices)
  && hasAtLeastOne(servicesCheckedIn(kioskServices))
  && !isCheckedInSelectedService(servicesCheckedIn(kioskServices), selectedService);

// Checks if student is checked into selected service and also in some other service in this multi-service kiosk.
// We use it in virtual check in flow, so we take student to checked in options instead of "select service" page,
// where physical kiosk flow would take them
export const isCheckedInAnotherServiceInAMultiServiceKioskAndInSelectedService = (kioskServices, selectedService) =>
  isMultiServiceKiosk(kioskServices)
  && hasMoreThanOne(servicesCheckedIn(kioskServices))
  && isCheckedInSelectedService(servicesCheckedIn(kioskServices), selectedService);

export const isNotCheckedInAMultiServiceKiosk = (kioskServices) =>
  hasNone(servicesCheckedIn(kioskServices)) && isMultiServiceKiosk(kioskServices);

export const hasNotCheckedInOrIsSingleServiceKiosk = (kioskServices) =>
  hasNone(servicesCheckedIn(kioskServices)) || isSingleServiceKiosk(kioskServices);

export const isCheckedInAnotherKioskAndNotInThisSingleServiceKiosk = (otherKioskServices, kioskServices) =>
  hasAtLeastOne(servicesCheckedIn(otherKioskServices)) && isNotCheckedInSingleKioskService(kioskServices);

export const isCheckedInOneService = (waitingRoomStatus, kioskServices) =>
  (isCheckedIn(waitingRoomStatus) && isSingleServiceKiosk(kioskServices)) || hasOnlyOne(servicesCheckedIn(kioskServices));

// select service router
export const isCheckedInBesidesSelectedService = (allServices, selectedService) =>
  hasAtLeastOne(servicesCheckedIn(allServices)) && !isCheckedIn(selectedService);

export const isUserCheckedInSelectedService = (allServices, selectedService) =>
  (hasAtLeastOne(servicesCheckedIn(allServices)) && isCheckedIn(selectedService)) ||
    isCheckedInSelectedService(servicesCheckedIn(allServices), selectedService);

export const hasNotVisitedServiceWithAppointment = (service, servicesIdWithAppointmentVisited) =>
  !servicesIdWithAppointmentVisited.includes(service.serviceId);
